import { render, staticRenderFns } from "./BadCreditLoans.vue?vue&type=template&id=2b8d4f5c&"
import script from "./BadCreditLoans.vue?vue&type=script&lang=js&"
export * from "./BadCreditLoans.vue?vue&type=script&lang=js&"
import style0 from "./BadCreditLoans.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports